import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment } from "react";
import PropTypes from "prop-types";
import { DividerImpl } from "../divider/divider.styles.es.js";
import { StackWrapper, StackItem } from "./stack.styles.es.js";
import { flattenChildren } from "../../utils/flatten-children.es.js";
const propTypes = {
  alignX: PropTypes.oneOf(["center", "left", "right", "stretch"]),
  as: PropTypes.elementType,
  children: PropTypes.node,
  dividers: PropTypes.bool,
  space: PropTypes.oneOf([
    "none",
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge"
  ]).isRequired
};
const defaultProps = {
  alignX: void 0,
  as: void 0,
  children: void 0,
  dividers: false
};
const Stack = forwardRef(
  ({ alignX, as, children, dividers, space }, forwardedRef) => {
    const isList = as === "ol" || as === "ul";
    const hasNonZeroSpace = [
      "xsmall",
      "small",
      "medium",
      "large",
      "xlarge"
    ].includes(space);
    if (dividers) {
      if (isList) {
        console.warn(`Stack: dividers prop invalid when as="${as}"`);
      } else if (!hasNonZeroSpace) {
        console.warn(`Stack: dividers prop invalid when space="none"`);
      }
    }
    const childrenArray = flattenChildren(children).filter((ch) => ch);
    const showDividers = dividers && !isList && hasNonZeroSpace;
    return /* @__PURE__ */ jsx(StackWrapper, { as, ref: forwardedRef, $alignX: alignX, $space: space, children: childrenArray.map((child, i) => /* @__PURE__ */ jsxs(Fragment, { children: [
      showDividers && i > 0 && /* @__PURE__ */ jsx(StackItem, { as: DividerImpl }),
      /* @__PURE__ */ jsx(StackItem, { as: isList ? "li" : void 0, children: child })
    ] }, child.key)) });
  }
);
Stack.propTypes = propTypes;
Stack.defaultProps = defaultProps;
export {
  Stack
};
